module.exports = __webpack_public_path__ + "static/img/getBtn.70d4964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/depositActivity/getBtn.png
// module id = NeCd
// module chunks = 0